// Estimates reading time from the real postData content (no readTime field exists on post objects).
const WORDS_PER_MINUTE = 200;

const collectText = (value, out) => {
    if (!value) return;
    if (typeof value === 'string') { out.push(value); return; }
    if (Array.isArray(value)) { value.forEach(v => collectText(v, out)); return; }
    if (typeof value === 'object') { Object.values(value).forEach(v => collectText(v, out)); }
};

export const estimateReadTime = (postData) => {
    const chunks = [];
    collectText(postData, chunks);
    const wordCount = chunks.join(' ').trim().split(/\s+/).filter(Boolean).length;
    return Math.max(1, Math.round(wordCount / WORDS_PER_MINUTE));
};

export const authorName = (post) => (post?.author?.name || '').replace(/,\s*$/, '');
